/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Scope_TeamInputs */

const en_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const fr_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const de_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const it_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const ru_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const es_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const zh_cn2_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const ja_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const hi_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const pt_pt2_explorer_search_scope_team = /** @type {(inputs: Explorer_Search_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Explorer_Search_Scope_TeamInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_scope_team = /** @type {((inputs?: Explorer_Search_Scope_TeamInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Scope_TeamInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_scope_team(inputs)
	if (locale === "de") return de_explorer_search_scope_team(inputs)
	if (locale === "it") return it_explorer_search_scope_team(inputs)
	if (locale === "ru") return ru_explorer_search_scope_team(inputs)
	if (locale === "es") return es_explorer_search_scope_team(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_scope_team(inputs)
	if (locale === "ja") return ja_explorer_search_scope_team(inputs)
	if (locale === "hi") return hi_explorer_search_scope_team(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_scope_team(inputs)
	return en_explorer_search_scope_team(inputs)
});